module.exports = __webpack_public_path__ + "img/badge_color_cap-careerplan.1d91437d.svg";